<template>
  <b-col cols="auto" class="pt-1 pl-0 pb-1 pr-0" >
    <div class="btn-group" role="group" >
    <slot>
    </slot>
    </div>
  </b-col>
</template>

<script>

  export default {
    name: "HeadersButtonGroup",
  }
</script>

<style scoped>

</style>